import { setTerm } from './helpers';

export const setOnlineBooking = setTerm('online_booking');
